(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["calma-express-checkout"] && !Shopify.designMode) return;
  try {
    if (!window.calmaExpressCheckoutInitialized) {
    window.calmaExpressCheckoutInitialized = true;
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-express-checkout]');
      if (!btn) return;
      e.preventDefault();
      const form = btn.closest('form');
      if (!form) return;
      if (!form.querySelector('input[name="return_to"]')) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'return_to';
        input.value = '/checkout';
        form.appendChild(input);
      }
      form.submit();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["calma-klarna"] && !Shopify.designMode) return;
  try {
    document.addEventListener('shopify:product:select', (event) => {
    const blocks = document.querySelectorAll('.glory-inst');
    if (!blocks.length) return;

    event.promise
      ?.then(({ detail }) => {
        const html = detail?.html;
        if (!html) return;

        blocks.forEach((current) => {
          const updated = html.querySelector(`#${CSS.escape(current.id)}`);
          if (!updated) return;

          current.style.display = updated.style.display;

          const from = current.querySelector('[data-inst-v]');
          const to = updated.querySelector('[data-inst-v]');
          if (from && to) from.textContent = to.textContent;
        });
      })
      .catch(() => {});
  });
  } catch(e) { console.error(e); }
})();

})();
